
;(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("SetValueConstant", function(){ return factory(root);});
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(root);
    } else {
        // Browser globals (root is window)
        root.SetValueConstant = factory(root);
    }
}(this, function(global) {
    "use strict";

    // Use previously defined object if exists in current scope
    var SetValueConstant = global && global.SetValueConstant || {};



    //SetValueConstant.l = SetValueConstant.localize.bind(SetValueConstant);


    return SetValueConstant;
}));
